import { Storage } from "./storage";

export const checkAuthState = () => Storage.getData("isLoggedIn");
